$(function () {
    var customers_rating = $('.customers-rating');
    customers_rating.slick({
        dots: true,
        arrow: true,
        focusOnSelect: true,
        infinite: false,
        speed: 500,
        slidesToShow: 5.7,
        slidesToScroll: 1,
        touchThreshold: 5,
        prevArrow: '<button class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><i class="fa-solid fa-angle-right"></i></button>',
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 4.7,
                    arrow: false,
                }
            },
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 3.7,
                    arrow: false,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2.9,
                    arrow: false,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2.2,
                    arrows: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.3,
                    arrows: false,
                }
            },
        ]
    });

    //rental-homepage

    var locationSlider = $('.location-slider');
    var totalSlides = $('.oscar-location-card').length; // Replace '.your-slide-class' with your actual slide class selector

    locationSlider.slick({
        dots: false,
        arrows: totalSlides > 1,
        focusOnSelect: true,
        infinite: true,
        loop: true,
        autoplay: true,
        speed: 500,
        slidesToShow: totalSlides >= 6 ? 6.15 : totalSlides,
        slidesToScroll: 1,
        touchThreshold: 5,
        centerPadding: '40px',
        centerMode: totalSlides < 6, // Enable center mode if less than 6 slides
        prevArrow: '<button class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><i class="fa-solid fa-angle-right"></i></button>',
        responsive: [
            {
                breakpoint: 1800,
                settings: {
                    slidesToShow: totalSlides >= 6 ? 5.2 : totalSlides,
                    centerMode: totalSlides < 5
                }
            },
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: totalSlides >= 4 ? 4.8 : totalSlides,
                    centerMode: totalSlides < 4
                }
            },
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: totalSlides >= 4 ? 4.1 : totalSlides,
                    centerMode: totalSlides < 4
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: totalSlides >= 3 ? 3.7 : totalSlides,
                    centerMode: totalSlides < 3
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: totalSlides >= 3 ? 3.6 : totalSlides,
                    centerMode: totalSlides < 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: totalSlides >= 2 ? 2.5 : totalSlides,
                    arrows: false,
                    centerMode: totalSlides < 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: totalSlides >= 2 ? 2.1 : totalSlides,
                    arrows: false,
                    centerMode: totalSlides < 2
                }
            },
        ]
    });

    const select = document.querySelector('.mobile-select select')
    select.addEventListener('change', (event) => {
        let tempSelect = document.createElement('select'),
            tempOption = document.createElement('option');

        tempOption.textContent = event.target.options[event.target.selectedIndex].text;
        tempSelect.style.cssText += `
        visibility: hidden;
        position: fixed;
        `;
        tempSelect.appendChild(tempOption);
        event.target.after(tempSelect);

        const tempSelectWidth = tempSelect.getBoundingClientRect().width;
        event.target.style.width = `${tempSelectWidth}px`;
        tempSelect.remove();
    });

    select.dispatchEvent(new Event('change'));
});

$(document).ready(function () {
    $('.rental-popular-cars .slick-list .slide > div.relative').on('click', function (event) {
        event.stopImmediatePropagation();
    });
    $('.rental-popular-cars .slick-list .slide').on('click', function (event) {
        event.stopImmediatePropagation();
    });
});
